import { TabProxy } from "encampy";

export async function automateWALogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("#username", { timeout: 10000 });

  // Type in the username
  await tab.type("#username", username);

  // Type in the password
  await tab.type("#password", password);

  // Click the submit button
  await tab.click("#submit-button-row > button[type='submit']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
